import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { BreadcrumbService } from '@suvo/frontend/standalone/breadcrumb';
import { ICpr } from '../interface/cpr.interface';
import { CprsService } from '../service/cprs.service';

@Injectable()
export class CprResolver implements Resolve<ICpr> {
  constructor(
    private readonly breadcrumb: BreadcrumbService,
    private readonly cpr: CprsService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot) {
    const cpr = await this.cpr.getOne('', route.params['id']);
    this.breadcrumb.setDynamicNameSwap('cprID', cpr.oldCprId.toString());
    return cpr;
  }
}
